import {match} from 'ts-pattern';

import {always} from 'ramda';

import {EntityResourceIds} from '@dms/api/shared';
import {
  businessCaseRoutes,
  customerRoutes,
  interestRoutes,
  rentalOrderRoutes,
  tiresInventoryRoutes,
  vehiclesRoutes,
  warehouseRoutes,
  workshopRoutes,
} from '@dms/routes';

import {composePath} from 'shared/web';

export function composeCustomNoticeSourcePath(resourceId: EntityResourceIds, recordId: string) {
  // recordId comes from the API response; react-router 7's generatePath percent-encodes
  // named params natively, so it must not be pre-encoded here (that would double-encode)
  return match(resourceId)
    .with(EntityResourceIds.vehicle, () =>
      composePath(vehiclesRoutes.detail, {params: {id: recordId}, isSearchParamsPreserved: false})
    )
    .with(EntityResourceIds.customer, () =>
      composePath(customerRoutes.detail, {params: {id: recordId}, isSearchParamsPreserved: false})
    )
    .with(EntityResourceIds.businessCase, () =>
      composePath(businessCaseRoutes.overview, {
        params: {id: recordId},
        isSearchParamsPreserved: false,
      })
    )
    .with(EntityResourceIds.interest, () =>
      composePath(interestRoutes.detailOverview, {
        params: {id: recordId},
        isSearchParamsPreserved: false,
      })
    )
    .with(EntityResourceIds.serviceCase, () =>
      composePath(workshopRoutes.serviceCaseDetail, {
        params: {id: recordId},
        isSearchParamsPreserved: false,
      })
    )
    .with(EntityResourceIds.tireOrder, () =>
      composePath(tiresInventoryRoutes.tireOrderDetail, {
        params: {id: recordId},
        isSearchParamsPreserved: false,
      })
    )
    .with(EntityResourceIds.rentalOrder, () =>
      composePath(rentalOrderRoutes.detail, {
        params: {id: recordId},
        isSearchParamsPreserved: false,
      })
    )
    .with(EntityResourceIds.workshopInterest, () =>
      composePath(workshopRoutes.interestDetailOverview, {
        params: {id: recordId},
        isSearchParamsPreserved: false,
      })
    )
    .with(EntityResourceIds.directSale, () =>
      composePath(warehouseRoutes.directSalesDetailOverview, {
        params: {id: recordId},
        isSearchParamsPreserved: false,
      })
    )
    .otherwise(always(undefined));
}
